var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:_vm.$route.name,attrs:{"height":"100%"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"conversation",attrs:{"fill-height":"","xs12":"","md3":""}},[_c('messenger-conversations')],1),_vm._v(" "),_c('v-flex',{staticClass:"messages",attrs:{"fill-height":"","xs12":"","md9":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de47638a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Messenger.vue
// module id = null
// module chunks = 